export default __webpack_public_path__ + "static/media/White Bookmark Icon.5dd4bed6.png";